<template>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import { afterPageLoad } from '@module/afterPageLoad';

export default {
  name: 'statistical',
  data(): DataInterface {
    return {
      href: {
        baidu: 'https://hm.baidu.com/hm.js'
      },
      expand: {
        baidu: 'd6aef46d118a1f0344ac98f6951b8d68'
      },
      cancelLoad: null
    };
  },
  watch: {
    $route: {
      handler(newData: any, oldDate: any): void {
        if (window._hmt) { // 百度
          window._hmt.push([ '_trackPageview', this.$route.path ]);
        }
      }
    }
  },
  mounted(): void {
    this.cancelLoad = afterPageLoad(() => this.initBaiDu().catch(() => {}));
  },
  beforeUnmount(): void {
    this.cancelLoad?.();
  },
  methods: {
    //----- 百度 Start -----//
    /**
     * 初始化百度统计
     */
    async initBaiDu(): Promise<any> {
      if (this.expand.baidu === '') return;
      
      await $FN.File.load(`${ this.href.baidu }?${ this.expand.baidu }`)
        .then((response: any) => {
          console.log(`${ $Config.Console.log }统计-百度：加载完成`, window._hmt);
        });
    }
    //----- 百度 End -----//
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';
</style>
